import moment from 'moment';

const IST_OFFSET = 330;
const DEFAULT_END_TIME = '23:59:59';

export function formatEndTimeForDisplay(endTime) {
  if (!endTime) {
    return null;
  }
  const parts = String(endTime).split(':');
  return `${parts[0]}:${parts[1]}`;
}

export function getTaskDeadlineMoment(endDate, endTime) {
  const deadline = moment(endDate).utcOffset(IST_OFFSET, true);
  const time = endTime ? formatEndTimeForDisplay(endTime) : DEFAULT_END_TIME;
  const [h, m, s = 0] = time.split(':');
  return deadline.set({
    hour: +h, minute: +m, second: +s, millisecond: 0,
  });
}

export function isTaskOverdue(endDate, endTime, statusId, completedStatusId) {
  if (!endDate || statusId === completedStatusId) {
    return false;
  }
  return getTaskDeadlineMoment(endDate, endTime).isBefore(moment().utcOffset(IST_OFFSET));
}

export function formatTaskEndDisplay(endDate, endTime) {
  if (!endDate) {
    return '---';
  }
  const deadline = getTaskDeadlineMoment(endDate, endTime);
  return endTime ? deadline.format('DD MMM YY, HH:mm') : deadline.format('DD MMM YY');
}

export function normalizeEndTimeForApi(endTime) {
  if (!endTime || (typeof endTime === 'string' && endTime.trim() === '')) {
    return null;
  }
  return formatEndTimeForDisplay(endTime);
}
